import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import contact from "../../service/contact";
import { Contact, ContactState } from "../../@type/contactType";


export const getContactDetail = createAsyncThunk(
    "get/getContact",
    async () => {
      const { data } = await contact.getById();
      return data;
    }
  );

  export const updateContactDetail = createAsyncThunk(
    "update/updateContact",
    async ({ a }: { a: Contact }) => {
      const { data } = await contact.updateById(a);
      return data;
    }
  );
const initialState: ContactState = {
    contactDetail: {
    id: 0,
    address: "",
    linkAddress: "",
    contact1: "",
    contact2: "",
    email: "",
    }
  
 
};

const globalSlide = createSlice({
  name: "global",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContactDetail.fulfilled, (state, action) => {
      state.contactDetail = action.payload;
    });
    builder.addCase(updateContactDetail.fulfilled, (state, action) => {
      state.contactDetail = action.payload;
    });
  },
});

export default globalSlide.reducer;
